import { useRef } from 'react';
import { PanResponder } from 'react-native';

interface UseExerciseInteractionPanResponderProps {
  isSelf?: boolean;
  preview?: boolean;
  touched: () => void;
}

/**
 * Resets the self-training idle timer on each patient interaction and records
 * that the exercise has been touched (used to gate navigation back to select).
 */
export function useExerciseInteractionPanResponder({
  isSelf,
  preview,
  touched,
}: UseExerciseInteractionPanResponderProps) {
  const isTouched = useRef(false);

  const panResponder = useRef(
    PanResponder.create({
      onStartShouldSetPanResponderCapture: () => {
        if (!isSelf || preview) {
          return false;
        }
        touched();
        isTouched.current = true;
        return false;
      },
    }),
  ).current;

  return { panResponder, isTouched };
}
